import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { LogoutService } from '../services/logout.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private authService: AuthenticationService, 
    private logoutService: LogoutService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const access = this.authService.getAccessToken();
    let authReq = req;
    if (access) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${access}`,
        },
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // If 401 and not already refreshing, try to refresh
        if (error.status === 401 && this.authService.getRefreshToken() && !this.isRefreshing) {
          this.isRefreshing = true;
          return from(this.authService.refreshToken(this.authService.getRefreshToken()!)).pipe(
            switchMap((res: any) => {
              this.isRefreshing = false;
              if (res && res.access) {
                this.authService.storeTokens({ access: res.access, refresh: res.refresh || this.authService.getRefreshToken()! });
                const retryReq = req.clone({
                  setHeaders: { Authorization: `Bearer ${res.access}` },
                });
                return next.handle(retryReq);
              } else {
                this.logoutService.logout('token_expired');
                return throwError(error);
              }
            }),
            catchError((refreshError) => {
              this.isRefreshing = false;
              this.logoutService.logout('token_expired');
              return throwError(refreshError || error);
            })
          );
        } else {
          // If already tried refresh or no refresh token, logout on 401
          if (error.status === 401) {
            this.logoutService.handleAuthenticationError(error);
          }
          return throwError(error);
        }
      })
    );
  }

}
